import 'amazon-connect-streams';
let agent;
const _setAgent = (newAgent) => {
    agent = newAgent;
};
export const getAgent = () => agent;
export const getAgentPromise = () => {
    return new Promise((resolve, reject) => {
        try {
            let agentSubscription = null;
            let retriesSubscription = null;
            const cleanUpSubscriptions = () => {
                if (agentSubscription?.unsubscribe) {
                    agentSubscription.unsubscribe();
                }
                if (retriesSubscription?.unsubscribe) {
                    retriesSubscription.unsubscribe();
                }
            };
            agentSubscription = connect.agent((_agent) => {
                cleanUpSubscriptions();
                resolve(_agent);
                _setAgent(_agent);
            });
            retriesSubscription = connect.core.onIframeRetriesExhausted(() => {
                cleanUpSubscriptions();
                reject(new Error('Failed to connect to amazon connect. Max retries reached'));
            });
        }
        catch (error) {
            reject(error);
        }
    });
};
export const activateAgent = async () => {
    const currentAgent = await getAgentPromise();
    const currentState = currentAgent.getState();
    if (currentState.type === connect.AgentStateType.ROUTABLE) {
        return; // already available
    }
    // set agent to online
    const states = currentAgent.getAgentStates();
    const routable = states.find((state) => state.type === connect.AgentStateType.ROUTABLE);
    if (!routable) {
        throw new Error('could not find a routable agent state');
    }
    return new Promise((resolve, reject) => currentAgent.setState(routable, {
        success: () => {
            resolve();
        },
        failure: (message) => reject(message),
    }));
};
export const callByPhoneNumber = async (props) => {
    const { queueARN, phoneNumber } = props;
    const _agent = await getAgentPromise();
    const endpoint = connect.Endpoint.byPhoneNumber(phoneNumber);
    const contact = new Promise((resolve) => {
        const sub = connect.contact((_contact) => {
            resolve(_contact);
            sub.unsubscribe();
        });
    });
    await new Promise((resolve, reject) => {
        _agent.connect(endpoint, {
            queueARN,
            success: () => {
                resolve();
            },
            failure: (message) => reject(message),
        });
    });
    return contact;
};
//# sourceMappingURL=data:application/json;base64,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